<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Denounced } from "../../../../Model/Denounced";
  import type { Third } from "../../../../Model/Third";
  import DenouncedInfoForm from "../../DenouncedInfoForm.svelte";
  import { bussinessService, denouncedActaService, denouncedService, directionsService } from "../../../../services";
  import type { DenouncedActa } from "../../../../Model/DenouncedActa";
    import type { Bussiness } from "../../../../Model/Bussiness";
    import DirectionFormForModal from "../../../DirectionFormForModal.svelte";
    import DirectionForm from "../../../DirectionForm.svelte";
    import VehicleInput from "../../../VehicleInput.svelte";
    import AddVehicleList from "../../../AddVehicleList.svelte";

  export let denouncedThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, denouncedThird)
  $: loadBussiness();

  let size = "lg";
  let denounced: Denounced;
  let denouncedActa: DenouncedActa;
  let directionExists: boolean;
  let editVehicle: boolean = false;

  let companies: Bussiness[] = []

  const dispatch = createEventDispatcher();

  async function load(diligenceId, denouncedThird){
    if (diligenceId && denouncedThird) {

      let denounceds: Denounced[] = await denouncedService.findByDiligenceNumber(diligenceId)
      denounced = denounceds.find(c => c.denouncedThirId == denouncedThird.id)

      if (denounced) {
        denouncedActa = await denouncedActaService.findOneByDiligenceNumber(denounced.diligenceNumber);
      }

    }
  }

  async function saveDenouncedTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    denounced.denouncedThirId = third.id;
    denouncedActa.denouncedThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      denouncedService.saveDenounced(denounced),
      denouncedActaService.saveDenouncedActa(denouncedActa)
    ])

    dispatch('saveDenounced');
  }

  async function loadBussiness() {

    companies = await bussinessService.findBussiness();
  }

  async function changeVehicleEvent(vehicleId) {
    denouncedActa.vehicleId = vehicleId;
    editVehicle = false
    save();
  }


</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <TabContent>
      <TabPane tabId="Datas" tab="Datos" active>
        {#if denounced}
          <DenouncedInfoForm denounced={denounced} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
      {#if denouncedActa}
      <TabPane tabId="1" tab="Laboral">
        <div class="row">
          <div class="col-12 mt-3 mb-3 d-flex flex-column">
            <Label>Empresa</Label>
            <select class='rounded-2 p-2' bind:value={denouncedActa.bussinessId}>
              {#each companies as bussiness}
                <option value={bussiness.id}>{bussiness.name}</option>
              {/each}
            </select>
            <!-- <Input type="text" bind:value={denouncedActa.bussinessId} /> -->
          </div>
          <div class="col-12">
            <Label>Dirección</Label>
            <Input type="text"  />
          </div>
        </div>
      </TabPane>
    
      <TabPane tabId="2" tab="Vehiculo">
        <div class="row">
          <div class="col-12 mb-3 mt-2">
            <Label for="matricula">Matricula</Label>
            <div class="input-group">
              <VehicleInput id={denouncedActa.vehicleId} />
              <button
                class="btn btn-secondary"
                type="button"
                id="complainantThirId"
                name="complainantThirId"
                on:click={() => { editVehicle = true; }}>
                <Icon name="plus" />
              </button>
            </div>
          </div>

          {#if editVehicle}
            <AddVehicleList on:changeVehicle={(event) => changeVehicleEvent(event.detail)} />
          {/if}

          <div class="col-12">
            <Label>Daños Vehiculo</Label>
            <Input type="text" bind:value={denouncedActa.vehicleDamage} />
          </div>
          <div class="col-12">
            <Label>Matricula Trailer</Label>
            <Input type="text" bind:value={denouncedActa.trailerPlate} />
          </div>
        </div>
      </TabPane>

      <TabPane tabId="3" tab="Lugar de infracción">
        <div class='mt-3'>
          <!-- {#if !denouncedActa.directionId}
						<DirectionFormForModal bind:directionId={denouncedActa.directionId} />	
					{:else}
						<DirectionForm bind:directionId={denouncedActa.directionId} thirdId='' />
					{/if} -->
          <DirectionForm bind:directionId={denouncedActa.directionId} thirdId='' />
        </div>
      </TabPane>
      {/if}

    </TabContent>

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveDenouncedTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

